<div class="loader">{{ 'loader.loading' | translate }}</div>
